<template>
    <div>
        <!-- Delete confirmation dialog -->
        <Teleport to="body">       
            <ConfirmationDialog ref="ConfirmationDialogRef" :confirmationDialogData="confirmationDialogData"
            :isLoading="isDeletingRate" />
        </Teleport>
        <!-- report comment -->
        <Teleport to="body">
            <MakeCommentReportModal
                :isProcessing="isReportingRate"
                :isOpen="isReportRatingModalOpen"
                :commentToReportObj="commentToReportObj"
                :changeModalState="changeReportModalState"
                :confirmReportingRate="confirmReportingRate"
            />
        </Teleport>
        <!-- shows when loading -->
        <div v-if="isLoading">
            <div class="modal-loader w-full h-full">
                <div class="lds-dual-ring"/>
              </div>
        </div>
        <!-- shows when the feekbacks list is ready -->
        <TransitionGroup v-else name="products-list" tag="ul" class="list-none flex flex-col gap-2">
            <template v-if="items && items.length > 0">

                <FeedbackItem 
                    v-for="item in items" :key="item.id"
                    :item="item"
                    :currentUserId ="currentUserId"
                    :onDeleteRating="onDeleteRating"
                    :onRatingReport="onRatingReport"
                    :onEditRating="onEditRatingOpenModal"
                    :handleLikeClick="handleLikeClick"
                    :disableDeletingAndReporting="disableDeletingAndReporting"
                    :typeRate="typeRate"
                />
            </template>
        </TransitionGroup>
        <!-- load more button -->
        <ClientOnly>
            <div v-if="!hasReachedFullPages && !isLoading" class="mt-4 sm:mt-5 flex justify-center">
                <button @click="() => handleLoadingMoreComments()"
                    :disabled="isLoading"
                    :class="`${isLoadingMore ? 'disabled' : ''} w-full sm:w-max flex items-center justify-center gap-2 overflow-hidden border-[2px] border-[#0963FF] hover:bg-[#0963FF]/90 hover:text-white min-w-[110px] sm:min-w-[9.375rem] md:min-w-[10rem] text-primary font-normal text-xs md:text-sm lg:text-[0.928rem] md:text-[0.938rem] 3xl:text-base px-5 sm:px-8 py-2 rounded-[0.625rem]`.trim()">
                    <span>{{ $t('general.show_more') }}</span>
                    <span v-if="isLoadingMore" className='loader flex items-center justify-center rounded-md'>
                        <span
                            className=' w-6 aspect-square rounded-full border-4 border-[#d0cfcf] border-t-[#ffff] animate-spin '></span>
                    </span>
                </button>
            </div>
        </ClientOnly>
    </div>
</template>

<script>
import defaultUserImage from "@/assets/images/default-user.svg";
import starIcon from "@/assets/images/star.svg";
import { onImageError } from "@/helpers";
import { ConfirmationDialog } from "@/components";
import { useGlobalStore } from '@/store/Modules/global';
import FeedbackItem from "./FeedbackItem.vue";
import MakeCommentReportModal from "./MakeCommentReportModal.vue";

export default {
    setup(){
        const global = useGlobalStore() || {};
        return {
            global
        }
    },
    data(){
        return {
            defaultUserImage,
            starIcon,
            ratingIdToDelete: "",
            commentToReportObj: null,
            confirmationDialogData: {
                title:'',
                isDangerous: true,
                confirmedFunc:()=>{},
            },
            isReportRatingModalOpen: false,
        }
    },
    props: {
        items: {
            type: Array,
            required: true,
            default: () => ([])
        },
        loadMoreComments: {
          type: Function,
          required: false
        },
        isLoading: {
          type: Boolean,
          default: false,
        },
        isLoadingMore: {
          type: Boolean,
          default: false,
          required: false
        },
        hasReachedFullPages: {
          type: Boolean,
          default: false,
          required: true
        },
        // new
        disableDeletingAndReporting: {
            type: Boolean,
            default: false,
            required: false,
        },
        confirmDeletingRate: {
            type: Function,
            required: false
        },
        confirmReportingRate: {
            type: Function,
            required: false
        },
        isDeletingRate: {
            type: Boolean,
            default: false,
            required: false,
        },
        isReportingRate: {
            type: Boolean,
            default: false,
            required: false,
        },
        onEditRatingOpenModal: {
            type: Function,
            required: false
        },
        handleLikeClick: {
            type: Function,
            required: false
        },
        typeRate: {
            type: String,
            required: false
        }
    },
    components: {
        FeedbackItem,
        ConfirmationDialog,
        MakeCommentReportModal
    },
    computed: {
        currentUserId(){
           return this.global?.localStorageCopy?.user?.id;
        }
    },
    methods: {
        onImageError,
        handleLoadingMoreComments(){
            if(this.isLoading) return;
            this.loadMoreComments();
        },
        changeReportModalState(newVal){
            this.isReportRatingModalOpen = newVal;
        },
        onDeleteRating({ itemId }) {
            this.ratingIdToDelete = itemId;
            this.confirmationDialogData = {
                ...this.confirmationDialogData,
                title: `${this.$t("general.delete_rating_question")}`,
                confirmedFunc: () => this.confirmDeletingRate(itemId),
            };
            this.$refs.ConfirmationDialogRef.openModal();
        },
        onRatingReport({ item }){
            this.commentToReportObj = item;
            this.changeReportModalState(true);
        }
    }
}
</script>

<style>

</style>